module.exports = "/fonts/vendor/quasar-extras/fontawesome/fa-solid-900.woff2?fb493903265cad425ccdf8e04fc2de61";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/fontawesome/fa-solid-900.woff2
// module id = iM00
// module chunks = 49